module.exports = __webpack_public_path__ + "img/prize8.8e8190c2.png";